export default __webpack_public_path__ + "static/media/G0670.34I-26410_-24246_0.1654023360000.64167467.jpg";